module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/settings/object-field-templates/object-field-templates.component.scss
// module id = ./src/app/settings/object-field-templates/object-field-templates.component.scss
// module chunks = main